var Backbone = require('backbone');

/**
 * Flag Stored on Viewer State to remember if the document was locked by the application, and from what source.
 * lockSource:
 * - now really the source of truth ( we no longer need 'isLocked' )
 * - array of actions that resulted in a successful document lock web service call, or
 *   if the document was already locked, added to keep state without another superfluous call
 * - if empty, the document is not locked by DV action
 * - process completely intertwined with api.lockActiveDocument, api.unlockActiveDocument
 * - Possible lock sources:
 *  - 'PG_NOTE_EDITING'
 *  - 'FIND_AND_REDACT'
 * - Note on needing to handle multiple source using an array:
 *  - we can't just set locked/isLocked; need to list the sources
 *  - isLocked is now really just a convenience; if an item is in the lockSource array, it must be locked
 *  - Example: if locked by find and redact search, then user hits create new page note, then he exits find and redact,
 *  ( but is still editing the note ), we need the document to remain locked by 'PG_NOTE_EDITING'
 */


module.exports = Backbone.Model.extend({

    defaults: {

        isLocked: false,  // Flag indicating that the document was locked by this application (actually now now necessary but doesn't hurt)
        lockSource: []

    },

    /**
     * Don't lock or unlock directly due to nature of > 1 lock being able to be applied
     * Called after successful lock web-service call, or
     * if the document already locked, added to the array without a call to lock again.
     */
    addLockSource: function( source ) {

        var newLockSource = _.unique( this.get('lockSource').concat( [source] ) );

        this.set({
            lockSource: newLockSource,
            isLocked: newLockSource.length > 0
        });

    },

    removeLockSource: function( source ) {

        var newLockSource = _.without( this.get('lockSource'), source );

        this.set({
            lockSource: newLockSource,
            isLocked: newLockSource.length > 0
        });

    },

    isLocked: function() {
        return this.get('isLocked');
    },

    isNotLocked: function() {
        return !this.get('isLocked');
    },

    lockSource: function() {
        return this.get('lockSource');
    },

    isLockedBySource: function( source ) {
        return this.isLocked() && this.lockSource().indexOf( source ) > -1;
    },

    isLockedByOtherSource: function( lockSource ) {
        return this.isLocked() && _.without( this.lockSource(), lockSource).length > 0;
    },

    isLockedByPageNoteEditing: function() {
        return this.isLockedBySource( 'PG_NOTE_EDITING' );
    },

    isLockedByFindAndRedact: function() {
        return this.isLockedBySource( 'FIND_AND_REDACT' );
    },

    printForDebug: function() {
        return JSON.stringify( this.get('isLocked') ) + '|' + JSON.stringify( this.get('lockSource') );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/state/docLockState.js
 ** module id = 103
 ** module chunks = 0
 **/